import Vue from 'vue'
import Vuex from 'vuex'
// 모든모듈 modules로 임포트
import * as modules from './modules'
import accountPersistent from "@/config/vuex/plugins/accountPersistent";
import supportApi from "@/api/support";
import constant from '@/config/const/const'

//VUEX 사용처리
Vue.use(Vuex)

//VUEX 스토어 생성
const store = new Vuex.Store({
    //전역 상태로 사용할것이 있다면 이곳에 추가
    state: {
        user: '',
        clientCdOptions: [
            {text: 'Hobis', value: 'hobis'},
            {text: 'Line Bank BT', value: 'lnbbt'},
            {text: 'Line Bank Customer Service', value: 'lnbcs'},
            {text: 'Hana Bank BT', value: 'khbbt'},
            {text: 'Hana Bank Customer Service', value: 'khbcs'},
        ],
        languageOptions: [{text:'ID',value:'ID'},{text:'EN',value:'EN'}],
        fullLanguageOptions: [{text:'Bahasa',value:'ID'},{text:'English',value:'EN'}],
        legacyParams: {},
        senderList: []
    },
    mutations: {
        setClientCdOptions: (state,payload) => {
            state.clientCdOptions = payload
        },
        setLegacyParams: (state,payload) => {
            state.legacyParams[payload.name] = payload.params
        },
        setSenderList: (state, payload) => {
            state.senderList = payload
        }
    },
    actions: {
        setClientCd({commit}) {
            supportApi.getClientCodeList(1).then(function(res) {
                if(res && res.data.code === 1000) {
                    let clientOptions = res.data.content.reduce((base,item)=> {
                        base = [...base,{text:item.codeNm,value:item.code}]
                        return base
                    },[])
                    commit('setClientCdOptions',clientOptions)
                }
            })
        },
        setSenderList({commit}) {
            supportApi.getSenderList().then(res => {
                if(res && res.data.code === 1000) {
                    commit(constant.ACTIONS.SET_SENDER_LIST, res.data.content)
                }
            })
        }
    },
    getters: {
        getClientCdOptions: (state) => () => {
            return state.clientCdOptions
        },
        getLanguageOptions: (state) => () => {
            return state.languageOptions
        },
        getLegacyParams : (state) => () => {
            return state.legacyParams
        },
        getSenderOptions: (state) => (queueType) => state.senderList.filter(value => value.useYn === 'Y' && value.codeVal1 === queueType),
        getSenderList: (state) => () => state.senderList,
        getFullLanguageOptions: (state) => () => state.fullLanguageOptions
    },
    modules: modules.default,
    plugins:[accountPersistent]
})

//스토어 배포
export default store
